import { newSpecPage } from '@stencil/core/testing';
import { ZeroAccount } from './zero-account';

describe('zero-account', () => {
  it('renders', async () => {
    const { root } = await newSpecPage({
      components: [ZeroAccount],
      html: '<zero-account></zero-account>',
    });
    expect(root).toEqualHtml(`
      <zero-account>
        <mock:shadow-root>
          <div>
            Hello, World! I'm
          </div>
        </mock:shadow-root>
      </zero-account>
    `);
  });

  it('renders with values', async () => {
    const { root } = await newSpecPage({
      components: [ZeroAccount],
      html: `<zero-account first="Stencil" last="'Don't call me a framework' JS"></zero-account>`,
    });
    expect(root).toEqualHtml(`
      <zero-account first="Stencil" last="'Don't call me a framework' JS">
        <mock:shadow-root>
          <div>
            Hello, World! I'm Stencil 'Don't call me a framework' JS
          </div>
        </mock:shadow-root>
      </zero-account>
    `);
  });
});
